export default "__VITE_ASSET__Der8lGWz__"